export enum ErrorMessages {
  FailedPostRequest = 'Something went wrong!',
  FailedGetRequest = 'Something went wrong!',
  FailedFileRequest = 'Please select the file of the proper format and size!',
  NoCandidateEmail = 'Please add candidate email',
}
